<div class="workspace-picker">
  <header class="workspace-picker__header">
    <div class="workspace-picker__heading">
      <h2 class="workspace-picker__title">
        {{ 'header.workspacePicker.title' | translate }}
      </h2>
      <p class="workspace-picker__subtitle">
        {{ 'header.workspacePicker.subtitle' | translate }}
      </p>
    </div>
    <button
      mat-icon-button
      type="button"
      class="workspace-picker__close"
      (click)="close()"
      [attr.aria-label]="'common.close' | translate"
    >
      <i-tabler name="x" class="flex"></i-tabler>
    </button>
  </header>

  <div class="workspace-picker__body">
    <ul class="workspace-picker__list" role="list">
      @for (company of data.companies; track company.id) {
        <li>
          <app-workspace-company-card
            [company]="company"
            [active]="isActive(company.id)"
            (selected)="pickCompany($event)"
          />
        </li>
      }
    </ul>

    @if (data.allowCreateBusiness !== false) {
      <button type="button" class="workspace-picker__create" (click)="openOwnBusiness()">
        <span class="workspace-picker__create-title">
          {{ createTitleKey | translate }}
        </span>
        <span class="workspace-picker__create-hint">
          {{ createHintKey | translate }}
        </span>
      </button>
    }
  </div>
</div>
